import { useState } from "react";
import { BsExclamationTriangle, BsSearch } from "react-icons/bs";

import Sidebar from "../../components/sidebar/Sidebar";
import InventoryAlertTable from "./InventoryAlertTable";

import "./InventoryAlert.css";

const InventoryAlert = () => {
  const [searchQuery, setSearchQuery] = useState("");

  return (
    <div className="inventory-alert-page">
      <Sidebar />

      <main className="inventory-alert-content">
        <div className="inventory-alert-container">
          {/* HEADER */}

          <header className="inventory-alert-header">
            <div>
              <h1>Low Inventory Stock</h1>

              <p>
                Review products that have fallen below their configured minimum
                stock level.
              </p>
            </div>
          </header>

          {/* TOOLBAR */}

          <div className="inventory-alert-toolbar">
            <div className="inventory-alert-search">
              <BsSearch />

              <input
                type="search"
                placeholder="Search by MPN, name, type or supplier..."
                value={searchQuery}
                onChange={(event) => setSearchQuery(event.target.value)}
              />

              {searchQuery && (
                <button type="button" onClick={() => setSearchQuery("")}>
                  Clear
                </button>
              )}
            </div>

            <div className="inventory-alert-indicator">
              <BsExclamationTriangle />

              <span>Below minimum stock</span>
            </div>
          </div>

          {/* TABLE */}

          <InventoryAlertTable searchQuery={searchQuery} />
        </div>
      </main>
    </div>
  );
};

export default InventoryAlert;
